import BreadCrumb from "components/common/BreadCrumb";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import { EmployeeAdvanceSettlementTable } from "./EmployeeAdvanceSettlementTable";
import { getDocumentTitle } from "utils/helpers";

const EmployeeAdvanceSettlementList = () => {
  document.title = getDocumentTitle("Employee Advance Settlements");
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Employee Advance Settlements" pageTitle="Finance" />
        <Card>
          <CardHeader>
            <h5 className="card-title mb-0">Settlement List</h5>
          </CardHeader>
          <CardBody>
            <EmployeeAdvanceSettlementTable />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default EmployeeAdvanceSettlementList;
